import CloseIcon from '@mui/icons-material/Close';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { Checkbox, DialogActions, DialogContent, DialogTitle, ListItem, ListItemText } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ControlpanelPrimaryButton, ControlpanelSecondaryButton, GrayIconButton } from '../../../components/StyledButton';
import { CustomDialog, CustomList } from '../../../components/StyledComponents';
import ImportDataDialog from '../UserManagement/ImportDataDialog';

const SelectDataToImportLeaveAndHolidayDialog = (props) => {
   const { t } = useTranslation();

   const [checkedItems, setCheckedItems] = useState({
      leaves: false,
      holidays: false,
   });

   const [openImportSelectedLeaveAndHoliday, setOpenImportSelectedLeaveAndHoliday] = useState(false);

   const handleOpenImportSelectedLeaveAndHoliday = () => {
      setOpenImportSelectedLeaveAndHoliday(true);
   };

   const handleCloseImportSelectedLeaveAndHoliday = () => {
      setOpenImportSelectedLeaveAndHoliday(false);
   };

   return (
      <div>
         <CustomDialog transitionDuration={300} maxWidth={'xl'} open={props.open} onClose={props.handleClose} keepMounted>
            <DialogTitle>
               <div className='flex justify-between'>
                  <div className='flex items-center gap-4'>
                     <p className='text-xl font-semibold '>Select data to import - Leaves And Holidays</p>
                  </div>
                  <GrayIconButton onClick={props.handleClose}>
                     <CloseIcon />
                  </GrayIconButton>
               </div>
            </DialogTitle>

            <DialogContent className='!py-0'>
               <div className='pt-5'>
                  <p>
                     Import data from external sources. Zip files and csv files are accepted. If your data archive is protected with a
                     password, use "Password protected" option when importing.
                  </p>
                  <div className='flex flex-col'>
                     <CustomList>
                        <ListItem>
                           <Checkbox
                              id='leaves'
                              checked={checkedItems.leaves}
                              onChange={() => setCheckedItems({ ...checkedItems, leaves: !checkedItems.leaves })}
                           />
                           <ListItemText primary='Leaves' />
                        </ListItem>
                        <ListItem>
                           <Checkbox
                              id='holidays'
                              checked={checkedItems.holidays}
                              onChange={() => setCheckedItems({ ...checkedItems, holidays: !checkedItems.holidays })}
                           />
                           <ListItemText primary='Holidays' />
                        </ListItem>
                     </CustomList>
                  </div>
               </div>
            </DialogContent>

            <DialogActions>
               <div className='flex gap-2 px-4 py-4'>
                  <ControlpanelSecondaryButton onClick={props.handleClose}>
                     <CloseIcon />
                     <p>{t('button.cancel')}</p>
                  </ControlpanelSecondaryButton>
                  <ControlpanelPrimaryButton onClick={handleOpenImportSelectedLeaveAndHoliday}>
                     <PlayArrowIcon />
                     <p>{t('button.start-import')}</p>
                  </ControlpanelPrimaryButton>
               </div>
            </DialogActions>
         </CustomDialog>
         {openImportSelectedLeaveAndHoliday && <ImportDataDialog onClose={handleCloseImportSelectedLeaveAndHoliday} />}
      </div>
   );
};

export default SelectDataToImportLeaveAndHolidayDialog;
